"use client";

import React from "react";
import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stores = [{
  id: "enniscorthy-office",
  name: "Enniscorthy Office",
  address: "Enniscorthy, Co. Wexford, Ireland",
  phone: "+353 89 400 0413",
  hours: "Mon-Fri: 08:00 - 18:00 | Sat: 09:00 - 13:00",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19254.374484444!2d-6.585444!3d52.501444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4867f60999999999%3A0x0!2zNTLCsDMwJzA1LjIiTiA2wrAzNScwNy42Ilc!5e0!3m2!1sen!2sie!4v1710000000000!5m2!1sen!2sie"
}];
export default function AsNossasLojasFisicas() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261474" id="direct-support" className="dark bg-background text-foreground relative overflow-hidden py-24">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-20">
        <div className="bg-ring/30 h-[500px] w-[800px] rounded-lg blur-[120px]" />
      </div>
      <div className="bg-grid-white/[0.02] absolute inset-0 bg-[length:32px_32px]" />

      <div className="container relative mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`mb-16 text-center transition-all duration-1000 ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="font-default mb-4 text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
            Our Local <span className="text-ring">Presence</span>
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg font-default">
            Visit our Enniscorthy office for expert technical assistance, 
            professional project consultations, and dedicated electrical support across Co. Wexford.
          </p>
        </div>

        <div ref={gridRef} className={`mb-16 flex justify-center transition-all duration-1000 delay-200 ${isGridVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {stores.map((store, i) => <div key={store.id} data-index={i} className="group relative flex flex-col gap-6 w-full max-w-2xl">
              {}
              <div className="border-border/50 bg-card/30 relative aspect-video w-full overflow-hidden rounded-md border shadow-lg backdrop-blur-sm transition-all duration-500 group-hover:border-ring/50 group-hover:shadow-ring/20">
                <div className="absolute inset-0 z-10 pointer-events-none" />
                <iframe src={store.mapUrl} width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title={`Map of ${store.name}`} className="h-full w-full opacity-70 invert hue-rotate-180 contrast-125 grayscale-[40%] transition-opacity duration-500 group-hover:opacity-90" />
              </div>

              {}
              <Card className="border-border/50 bg-card/50 relative overflow-hidden backdrop-blur-md transition-colors duration-300 group-hover:border-ring/30 rounded-md shadow-md">
                <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-transparent via-ring/50 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <CardHeader className="pb-4">
                  <CardTitle className="font-default text-xl text-ring flex items-center gap-2">
                    <MapPin className="h-6 w-6" />
                    {store.name}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col gap-4">
                  <div className="flex items-start gap-3">
                    <MapPin className="text-muted-foreground mt-0.5 h-5 w-5 shrink-0" />
                    <span className="text-foreground font-mono text-sm">{store.address}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Phone className="text-muted-foreground h-5 w-5 shrink-0" />
                    <span className="text-foreground font-mono text-sm">{store.phone}</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <Clock className="text-muted-foreground mt-0.5 h-5 w-5 shrink-0" />
                    <span className="text-foreground font-mono text-sm">{store.hours}</span>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div ref={ctaRef} className={`flex justify-center transition-all duration-1000 delay-400 ${isCtaVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Link to="/ContactPage">
            <Button size="lg" className="h-14 px-8 text-base font-default bg-ring text-white rounded-md shadow-lg shadow-ring/20 transition-all hover:shadow-ring/40 hover:-translate-y-1">
              <MessageCircle className="mr-2 h-5 w-5" />
              Request a Quote
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}